import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import SiteGate from "@/components/SiteGate";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Traditional from "@/pages/Traditional";
import White from "@/pages/White";
import Registry from "@/pages/Registry";
import Rsvp from "@/pages/Rsvp";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Public = ({ children }) => (
  <SiteGate>
    <Layout>{children}</Layout>
  </SiteGate>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/traditional" element={<Public><Traditional /></Public>} />
          <Route path="/white" element={<Public><White /></Public>} />
          <Route path="/registry" element={<Public><Registry /></Public>} />
          <Route path="/rsvp" element={<Public><Rsvp wedding="traditional" /></Public>} />
          <Route path="/rsvp/white" element={<Public><Rsvp wedding="white" /></Public>} />
          <Route path="/contact" element={<Public><Contact /></Public>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
